import store from '@/store';

import router from '@/router';

import { checkIsUpsellRequired } from '../helpers/check-is-upsell-required';


function goToOrderAtTableCart(navigationParams = {}) {
  const { dispatch } = store;

  const isUpsellRequired = checkIsUpsellRequired(store);

  /* Note: Don't render the upsell modal again, if a user is navigating from the upsell modal to the cart. */
  const { isUpsellOverride } = navigationParams;

  if (isUpsellRequired && !isUpsellOverride) {
    dispatch('modals/openModal', { name: 'upsellModal' }, { root: true });
  }
  else {
    const routerPayload = {
      name: 'orderAtTableCartSummaryPage',
      params: { merchantId: router.currentRoute.value.params.merchantId }
    };

    router.push(routerPayload);
  }
}

export { goToOrderAtTableCart };
